import { render, staticRenderFns } from "./coveShedAddressTable.vue?vue&type=template&id=55c4453b&scoped=true&"
import script from "./coveShedAddressTable.vue?vue&type=script&lang=js&"
export * from "./coveShedAddressTable.vue?vue&type=script&lang=js&"
import style0 from "./coveShedAddressTable.vue?vue&type=style&index=0&id=55c4453b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c4453b",
  null
  
)

export default component.exports